import { defineComponent, openBlock, createBlock, createVNode, createCommentVNode, toDisplayString, ref, onMounted, onUnmounted, watch, pushScopeId, popScopeId, resolveComponent, Fragment, renderList, withModifiers, withDirectives, vModelSelect, withScopeId, createStaticVNode, renderSlot, withCtx } from 'vue';

var script$6 = defineComponent({
  name: 'TPPagination',
  props: {
    pages: {
      type: Number
    },
    page: {
      type: Number,
      default: 1
    }
  },

  setup() {}

});

const _hoisted_1$2 = {
  key: 0,
  class: "pagination is-centered",
  role: "navigation",
  "aria-label": "pagination"
};
const _hoisted_2$2 = {
  class: "pagination-list"
};
const _hoisted_3$2 = {
  key: 0,
  class: "pagination-ellipsis"
};
const _hoisted_4$2 = {
  class: "pagination-link is-current",
  "aria-current": "page"
};
const _hoisted_5$2 = {
  key: 0,
  class: "pagination-ellipsis"
};
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.pages && _ctx.pages > 1 ? (openBlock(), createBlock("nav", _hoisted_1$2, [createVNode("a", {
    class: "pagination-previous",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:page', _ctx.page > 1 ? _ctx.page - 1 : _ctx.page))
  }, "Previous"), createVNode("a", {
    class: "pagination-next",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('update:page', _ctx.page < _ctx.pages ? _ctx.page + 1 : _ctx.page))
  }, "Next page"), createVNode("ul", _hoisted_2$2, [createVNode("li", null, [_ctx.page > 2 ? (openBlock(), createBlock("a", {
    key: 0,
    class: "pagination-link",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('update:page', 1))
  }, "1")) : createCommentVNode("", true)]), createVNode("li", null, [_ctx.page > 3 ? (openBlock(), createBlock("span", _hoisted_3$2, "…")) : createCommentVNode("", true)]), createVNode("li", null, [_ctx.page > 1 ? (openBlock(), createBlock("a", {
    key: 0,
    class: "pagination-link",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('update:page', _ctx.page > 1 ? _ctx.page - 1 : _ctx.page))
  }, toDisplayString(_ctx.page - 1), 1)) : createCommentVNode("", true)]), createVNode("li", null, [createVNode("a", _hoisted_4$2, toDisplayString(_ctx.page), 1)]), createVNode("li", null, [_ctx.page < _ctx.pages ? (openBlock(), createBlock("a", {
    key: 0,
    class: "pagination-link",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.$emit('update:page', _ctx.page < _ctx.pages ? _ctx.page + 1 : _ctx.page))
  }, toDisplayString(_ctx.page + 1), 1)) : createCommentVNode("", true)]), createVNode("li", null, [_ctx.page < _ctx.pages - 2 ? (openBlock(), createBlock("span", _hoisted_5$2, "…")) : createCommentVNode("", true)]), createVNode("li", null, [_ctx.page < _ctx.pages - 1 ? (openBlock(), createBlock("a", {
    key: 0,
    class: "pagination-link",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.$emit('update:page', _ctx.pages))
  }, toDisplayString(_ctx.pages), 1)) : createCommentVNode("", true)])])])) : createCommentVNode("", true);
}

script$6.render = render$6;

var script$5 = defineComponent({
  name: 'TPDataGridCore',
  components: {
    TPPagination: script$6
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    result: {
      type: Object,
      required: true
    }
  },
  emits: ['fetch'],

  setup(props, {
    emit
  }) {
    const page = ref(1);
    const columns = ref(props.config.columns.map(config => {
      return {
        config,
        condition: {
          operator: 'eq'
        }
      };
    }));

    function orderBy(name) {
      columns.value.forEach(column => {
        if (column.config.name === name) {
          column.orderBy = !column.orderBy ? 'ASC' : column.orderBy === 'ASC' ? 'DESC' : undefined;
        } else {
          column.orderBy = undefined;
        }
      });
    }

    function hideFilters() {
      const activeDropdowns = document.getElementsByClassName('dropdown is-active');

      for (const dropdown of activeDropdowns) {
        dropdown.classList.remove('is-active');
      }
    }

    function showFilter(event) {
      const element = event.target.closest('.dropdown');
      const isActive = element.classList.contains('is-active');
      hideFilters();

      if (!isActive) {
        element.classList.add('is-active');
      }
    }

    let timeoutRef = null;

    function debounce(callback) {
      if (timeoutRef !== null) window.clearTimeout(timeoutRef);
      timeoutRef = window.setTimeout(async () => {
        callback();
      }, 500);
    }

    onMounted(() => {
      document.addEventListener('click', hideFilters);
    });
    onUnmounted(() => {
      document.removeEventListener('click', hideFilters);
    });
    watch(() => {
      const params = {
        page: page.value,
        conditions: []
      };
      columns.value.forEach(column => {
        if (column.condition.value) {
          params.conditions.push({
            name: column.config.name,
            operator: column.condition.operator,
            value: column.condition.value
          });
        }

        if (column.orderBy) {
          params.orderBy = {
            name: column.config.name,
            value: column.orderBy
          };
        }
      });
      return params;
    }, (params, old) => {
      if (params.page !== 1 && params.page === old.page) page.value = 1;else {
        emit('fetch', params);
        hideFilters();
      }
    }, {
      deep: true
    });
    return {
      columns,
      page,
      debounce,
      showFilter,
      orderBy
    };
  }

});

const _withId$1 = /*#__PURE__*/withScopeId("data-v-d7768af2");

pushScopeId("data-v-d7768af2");

const _hoisted_1$1 = {
  class: "wrapper"
};
const _hoisted_2$1 = {
  key: 0,
  class: "is-overlay"
};

const _hoisted_3$1 = /*#__PURE__*/createVNode("progress", {
  class: "progress is-small is-primary",
  max: "100"
}, "15%", -1);

const _hoisted_4$1 = {
  class: "columns is-vcentered"
};
const _hoisted_5$1 = {
  class: "column pr-0 mr-5"
};
const _hoisted_6$1 = {
  key: 0,
  class: "column is-narrow p-0 is-flex"
};
const _hoisted_7$1 = {
  key: 0,
  class: "material-icons"
};
const _hoisted_8$1 = {
  key: 1,
  class: "material-icons"
};
const _hoisted_9$1 = {
  key: 2,
  class: "material-icons"
};
const _hoisted_10$1 = {
  key: 1,
  class: "column is-narrow p-0 is-flex"
};
const _hoisted_11$1 = {
  class: "dropdown-trigger"
};

const _hoisted_12$1 = /*#__PURE__*/createVNode("span", {
  class: "material-icons"
}, "manage_search", -1);

const _hoisted_13$1 = {
  class: "dropdown-menu",
  role: "menu"
};
const _hoisted_14$1 = {
  class: "dropdown-content dropdown-filter"
};
const _hoisted_15$1 = {
  key: 0,
  class: "dropdown-item columns"
};
const _hoisted_16$1 = {
  class: "column is-one-quarter"
};

const _hoisted_17$1 = /*#__PURE__*/createVNode("option", {
  value: "eq"
}, "=", -1);

const _hoisted_18$1 = /*#__PURE__*/createVNode("option", {
  value: "not"
}, "!=", -1);

const _hoisted_19$1 = /*#__PURE__*/createVNode("option", {
  value: "like"
}, "%%", -1);

const _hoisted_20$1 = {
  class: "column"
};
const _hoisted_21$1 = {
  key: 1,
  class: "dropdown-item columns"
};
const _hoisted_22$1 = {
  class: "column is-one-quarter"
};

const _hoisted_23$1 = /*#__PURE__*/createStaticVNode("<option value=\"eq\" data-v-d7768af2>=</option><option value=\"not\" data-v-d7768af2>!=</option><option value=\"lt\" data-v-d7768af2>&lt;</option><option value=\"lte\" data-v-d7768af2>&lt;=</option><option value=\"gt\" data-v-d7768af2>&gt;</option><option value=\"gte\" data-v-d7768af2>&gt;=</option>", 6);

const _hoisted_29 = {
  class: "column"
};
const _hoisted_30 = {
  key: 2,
  class: "dropdown-item columns"
};
const _hoisted_31 = {
  class: "column is-one-quarter"
};

const _hoisted_32 = /*#__PURE__*/createStaticVNode("<option value=\"eq\" data-v-d7768af2>=</option><option value=\"not\" data-v-d7768af2>!=</option><option value=\"lt\" data-v-d7768af2>&lt;</option><option value=\"lte\" data-v-d7768af2>&lt;=</option><option value=\"gt\" data-v-d7768af2>&gt;</option><option value=\"gte\" data-v-d7768af2>&gt;=</option>", 6);

const _hoisted_38 = {
  class: "column"
};
const _hoisted_39 = {
  key: 1,
  class: "notification is-danger is-light"
};

popScopeId();

const render$5 = /*#__PURE__*/_withId$1((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_TPPagination = resolveComponent("TPPagination");

  return openBlock(), createBlock("div", _hoisted_1$1, [_ctx.result.loading ? (openBlock(), createBlock("div", _hoisted_2$1, [_hoisted_3$1])) : createCommentVNode("", true), createVNode("table", {
    class: `table is-fullwidth is-bordered ${_ctx.config.class}`
  }, [createVNode("thead", null, [createVNode("tr", null, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.columns, (column, index) => {
    return openBlock(), createBlock("th", {
      key: index
    }, [createVNode("div", _hoisted_4$1, [createVNode("div", _hoisted_5$1, toDisplayString(column.config.title), 1), column.config.orderBy ? (openBlock(), createBlock("div", _hoisted_6$1, [createVNode("button", {
      class: ["button header-button is-inverted", {
        'is-primary': column.orderBy,
        'is-grey': !column.orderBy
      }],
      onClick: $event => _ctx.orderBy(column.config.name)
    }, [!column.orderBy ? (openBlock(), createBlock("span", _hoisted_7$1, "unfold_more")) : createCommentVNode("", true), column.orderBy === 'ASC' ? (openBlock(), createBlock("span", _hoisted_8$1, "expand_less")) : createCommentVNode("", true), column.orderBy === 'DESC' ? (openBlock(), createBlock("span", _hoisted_9$1, "expand_more")) : createCommentVNode("", true)], 10, ["onClick"])])) : createCommentVNode("", true), column.config.conditionType || column.config.conditionOptions ? (openBlock(), createBlock("div", _hoisted_10$1, [createVNode("div", {
      class: ["dropdown", {
        'is-left': index === 0,
        'is-right': index > 0
      }],
      onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"]))
    }, [createVNode("div", _hoisted_11$1, [createVNode("button", {
      class: ["button header-button is-inverted", {
        'is-primary': column.condition.value,
        'is-grey': !column.condition.value
      }],
      onClick: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.showFilter && _ctx.showFilter(...args), ["stop"]))
    }, [_hoisted_12$1], 2)]), createVNode("div", _hoisted_13$1, [createVNode("div", _hoisted_14$1, [column.config.conditionType === 'text' ? (openBlock(), createBlock("div", _hoisted_15$1, [createVNode("div", _hoisted_16$1, [withDirectives(createVNode("select", {
      name: `operator_${column.config.name}`,
      class: "input",
      "onUpdate:modelValue": $event => column.condition.operator = $event
    }, [_hoisted_17$1, _hoisted_18$1, _hoisted_19$1], 8, ["name", "onUpdate:modelValue"]), [[vModelSelect, column.condition.operator]])]), createVNode("div", _hoisted_20$1, [createVNode("input", {
      name: `filter_${column.config.name}`,
      class: "input",
      type: "search",
      onInput: $event => _ctx.debounce(() => {
        column.condition.value = $event.target.value;
      })
    }, null, 40, ["name", "onInput"])])])) : createCommentVNode("", true), column.config.conditionType === 'number' ? (openBlock(), createBlock("div", _hoisted_21$1, [createVNode("div", _hoisted_22$1, [withDirectives(createVNode("select", {
      name: `operator_${column.config.name}`,
      class: "input",
      "onUpdate:modelValue": $event => column.condition.operator = $event
    }, [_hoisted_23$1], 8, ["name", "onUpdate:modelValue"]), [[vModelSelect, column.condition.operator]])]), createVNode("div", _hoisted_29, [createVNode("input", {
      name: `filter_${column.config.name}`,
      class: "input",
      type: "search",
      onInput: $event => _ctx.debounce(() => {
        column.condition.value = $event.target.value;
      })
    }, null, 40, ["name", "onInput"])])])) : createCommentVNode("", true), column.config.conditionType === 'date' || column.config.conditionType === 'datetime' ? (openBlock(), createBlock("div", _hoisted_30, [createVNode("div", _hoisted_31, [withDirectives(createVNode("select", {
      name: `operator_${column.config.name}`,
      class: "input",
      "onUpdate:modelValue": $event => column.condition.operator = $event
    }, [_hoisted_32], 8, ["name", "onUpdate:modelValue"]), [[vModelSelect, column.condition.operator]])]), createVNode("div", _hoisted_38, [createVNode("input", {
      name: `filter_${column.config.name}`,
      class: "input",
      type: column.config.conditionType === 'date' ? 'date' : 'datetime-local',
      onInput: $event => _ctx.debounce(() => {
        column.condition.value = $event.target.value;
      })
    }, null, 40, ["name", "type", "onInput"])])])) : createCommentVNode("", true), column.config.conditionOptions ? (openBlock(true), createBlock(Fragment, {
      key: 3
    }, renderList(column.config.conditionOptions, option => {
      return openBlock(), createBlock("a", {
        class: "dropdown-item",
        onClick: $event => column.condition.value = option
      }, toDisplayString(option.toString()), 9, ["onClick"]);
    }), 256)) : createCommentVNode("", true)])])], 2)])) : createCommentVNode("", true)])]);
  }), 128))])]), createVNode("tbody", null, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.result.data, row => {
    return openBlock(), createBlock("tr", null, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.config.columns, column => {
      return openBlock(), createBlock("td", null, toDisplayString(column.print(row)), 1);
    }), 256))]);
  }), 256))])], 2), _ctx.result.error ? (openBlock(), createBlock("div", _hoisted_39, toDisplayString(_ctx.result.error), 1)) : createCommentVNode("", true), createVNode(_component_TPPagination, {
    pages: _ctx.result.pages,
    page: _ctx.page,
    "onUpdate:page": _cache[3] || (_cache[3] = $event => _ctx.page = $event)
  }, null, 8, ["pages", "page"])]);
});

script$5.render = render$5;
script$5.__scopeId = "data-v-d7768af2";

var has$1 = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has$1.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has$1.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$1.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

var encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var utils = {
    arrayToObject: arrayToObject,
    assign: assign,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var formats = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults$1 = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults$1.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults$1.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults$1.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults$1.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults$1.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults$1.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults$1.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var parse = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify_1
};

var script$4 = defineComponent({
  name: 'TPDataGridApi',
  components: {
    TPDataGridCore: script$5
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ['fetch'],

  setup(props, {
    emit
  }) {
    const result = ref({
      data: []
    });

    async function fetch(params) {
      const conditions = {};
      let page = 1;

      if (params) {
        for (const condition of params.conditions) {
          const conditionObj = {};
          Reflect.set(conditionObj, condition.operator, condition.value);
          Reflect.set(conditions, condition.name, conditionObj);
        }

        if (params.orderBy) {
          Reflect.set(conditions, 'sort_by', params.orderBy.name);
          Reflect.set(conditions, 'order', params.orderBy.value);
        }

        if (params.page) page = params.page;
      }

      if (props.config.pageSize) {
        Reflect.set(conditions, 'limit', props.config.pageSize);
        Reflect.set(conditions, 'offset', props.config.pageSize * (page - 1));
      }

      result.value.loading = true;
      result.value.error = undefined;

      try {
        const response = await props.config.api.get('?' + lib.stringify(conditions));
        result.value.data = response.data;

        if (props.config.pageSize) {
          result.value.pages = Math.ceil(parseInt(response.headers['x-total-count']) / props.config.pageSize);
        }

        emit('fetch', result.value.data);
        result.value.loading = false;
      } catch (e) {
        result.value.data = [];
        result.value.pages = undefined;
        result.value.error = e.response.data.message;
        result.value.loading = false;
      }
    }

    onMounted(() => {
      fetch();
    });
    return {
      result,
      fetch
    };
  }

});

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TPDataGridCore = resolveComponent("TPDataGridCore");

  return openBlock(), createBlock(_component_TPDataGridCore, {
    config: _ctx.config,
    result: _ctx.result,
    onFetch: _ctx.fetch
  }, null, 8, ["config", "result", "onFetch"]);
}

script$4.render = render$4;

var script$3 = defineComponent({
  name: 'TPDataGridJson',
  components: {
    TPDataGridCore: script$5
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    json: {
      type: Array,
      required: true
    }
  },
  emits: ['fetch'],

  setup(props, {
    emit
  }) {
    const result = ref({
      data: []
    });

    async function fetch(params) {
      let page = 1;
      result.value.data = props.json;

      if (params) {
        if (params.conditions.length) {
          result.value.data = params.conditions.reduce((acc, condition) => {
            return acc.filter(el => {
              const original = Reflect.get(el, condition.name).toLowerCase();
              let filter = condition.value.toLowerCase();
              if (typeof original === 'number') filter = parseFloat(filter);
              if (typeof original === 'boolean') filter = !!filter;

              if (condition.operator === 'eq') {
                return original === filter;
              } else if (condition.operator === 'like') {
                return original.includes(filter);
              } else if (condition.operator === 'gt') {
                return original > filter;
              } else if (condition.operator === 'gte') {
                return original >= filter;
              } else if (condition.operator === 'lt') {
                return original < filter;
              } else if (condition.operator === 'lte') {
                return original <= filter;
              } else if (condition.operator === 'not') {
                return original !== filter;
              } else {
                return true;
              }
            });
          }, result.value.data);
        }

        if (params.orderBy) {
          result.value.data = result.value.data.sort((a, b) => {
            let order = Reflect.get(a, params.orderBy.name) > Reflect.get(b, params.orderBy.name) ? 1 : -1;
            if (params.orderBy.value === 'DESC') order = order * -1;
            return order;
          });
        }

        if (params.page) page = params.page;
      }

      if (props.config.pageSize) {
        const position = (page - 1) * props.config.pageSize;
        result.value.pages = Math.ceil(result.value.data.length / props.config.pageSize);
        result.value.data = result.value.data.slice(position, position + props.config.pageSize);
      }

      emit('fetch', result.value.data);
    }

    onMounted(() => {
      fetch();
    });
    return {
      result,
      fetch
    };
  }

});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TPDataGridCore = resolveComponent("TPDataGridCore");

  return openBlock(), createBlock(_component_TPDataGridCore, {
    config: _ctx.config,
    result: _ctx.result,
    onFetch: _ctx.fetch
  }, null, 8, ["config", "result", "onFetch"]);
}

script$3.render = render$3;

var script$2 = defineComponent({
  name: 'TPDataListCore',
  components: {
    TPPagination: script$6
  },
  emits: ['fetch'],
  props: {
    config: {
      type: Object,
      required: true
    },
    result: {
      type: Object,
      required: true
    }
  },

  setup(props, {
    emit
  }) {
    const page = ref(1);
    const showOrders = ref(false);
    const showFilters = ref(false);
    const conditions = ref({});
    const orderBy = ref({});
    props.config.conditions.forEach(condition => {
      Reflect.set(conditions.value, condition.name, {
        operator: 'eq',
        value: undefined
      });
    });
    let timeoutRef = null;

    function debounce(callback) {
      if (timeoutRef !== null) window.clearTimeout(timeoutRef);
      timeoutRef = window.setTimeout(async () => {
        callback();
      }, 500);
    }

    function setOrderBy(name) {
      if (orderBy.value.name !== name || orderBy.value.value === undefined) {
        orderBy.value.name = name;
        orderBy.value.value = 'ASC';
      } else if (orderBy.value.value === 'ASC') {
        orderBy.value.value = 'DESC';
      } else if (orderBy.value.value === 'DESC') {
        orderBy.value.name = undefined;
        orderBy.value.value = undefined;
      }
    }

    function isFiltered() {
      return Object.values(conditions.value).some(condition => !!Reflect.get(condition, 'value'));
    }

    watch(() => {
      const params = {
        page: page.value,
        conditions: []
      };
      Object.keys(conditions.value).forEach(key => {
        const condition = Reflect.get(conditions.value, key);

        if (condition.value) {
          params.conditions.push({
            name: key,
            operator: condition.operator,
            value: condition.value
          });
        }
      });

      if (orderBy.value.name && orderBy.value.value) {
        params.orderBy = {
          name: orderBy.value.name,
          value: orderBy.value.value
        };
      }

      return params;
    }, (params, old) => {
      if (params.page !== 1 && params.page === old.page) page.value = 1;else {
        emit('fetch', params);
        showFilters.value = false;
        showOrders.value = false;
      }
    }, {
      deep: true
    });
    return {
      page,
      showOrders,
      showFilters,
      conditions,
      orderBy,
      debounce,
      setOrderBy,
      isFiltered
    };
  }

});

const _withId = /*#__PURE__*/withScopeId("data-v-904eb2c6");

pushScopeId("data-v-904eb2c6");

const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "is-overlay"
};

const _hoisted_3 = /*#__PURE__*/createVNode("progress", {
  class: "progress is-small is-primary",
  max: "100"
}, "15%", -1);

const _hoisted_4 = {
  class: "is-flex is-justify-content-flex-end mb-4"
};
const _hoisted_5 = {
  class: "dropdown-trigger"
};
const _hoisted_6 = {
  key: 0,
  class: "material-icons"
};
const _hoisted_7 = {
  key: 1,
  class: "material-icons"
};
const _hoisted_8 = {
  key: 2,
  class: "material-icons"
};
const _hoisted_9 = {
  class: "dropdown-menu",
  role: "menu"
};
const _hoisted_10 = {
  class: "dropdown-content"
};
const _hoisted_11 = {
  class: "column is-flex is-align-items-center"
};
const _hoisted_12 = {
  class: "is-size-6"
};
const _hoisted_13 = {
  class: "column is-narrow"
};
const _hoisted_14 = {
  key: 0,
  class: "material-icons"
};
const _hoisted_15 = {
  key: 1,
  class: "material-icons"
};
const _hoisted_16 = {
  key: 2,
  class: "material-icons"
};
const _hoisted_17 = {
  class: "dropdown-trigger"
};

const _hoisted_18 = /*#__PURE__*/createVNode("span", {
  class: "material-icons"
}, "manage_search", -1);

const _hoisted_19 = {
  class: "dropdown-menu",
  role: "menu"
};
const _hoisted_20 = {
  class: "dropdown-content dropdown-filter"
};
const _hoisted_21 = {
  class: "column is-one-third is-flex is-align-items-center"
};
const _hoisted_22 = {
  class: "is-size-6"
};
const _hoisted_23 = {
  class: "column is-one-fifth"
};

const _hoisted_24 = /*#__PURE__*/createVNode("option", {
  value: "eq"
}, "=", -1);

const _hoisted_25 = /*#__PURE__*/createVNode("option", {
  value: "not"
}, "!=", -1);

const _hoisted_26 = /*#__PURE__*/createVNode("option", {
  value: "like"
}, "%%", -1);

const _hoisted_27 = {
  class: "column"
};
const _hoisted_28 = {
  key: 1,
  class: "notification is-danger is-light"
};

popScopeId();

const render$2 = /*#__PURE__*/_withId((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_TPPagination = resolveComponent("TPPagination");

  return openBlock(), createBlock("div", _hoisted_1, [_ctx.result.loading ? (openBlock(), createBlock("div", _hoisted_2, [_hoisted_3])) : createCommentVNode("", true), createVNode("div", _hoisted_4, [createVNode("div", {
    class: ["dropdown is-right", {
      'is-active': _ctx.showOrders
    }],
    onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"]))
  }, [createVNode("div", _hoisted_5, [createVNode("button", {
    class: ["button is-light mr-2", {
      'is-primary': _ctx.orderBy.value,
      'is-grey': !_ctx.orderBy.value
    }],
    onClick: _cache[1] || (_cache[1] = $event => {
      _ctx.showFilters = false;
      _ctx.showOrders = !_ctx.showOrders;
    })
  }, [!_ctx.orderBy.value ? (openBlock(), createBlock("span", _hoisted_6, "unfold_more")) : createCommentVNode("", true), _ctx.orderBy.value === 'ASC' ? (openBlock(), createBlock("span", _hoisted_7, "expand_less")) : createCommentVNode("", true), _ctx.orderBy.value === 'DESC' ? (openBlock(), createBlock("span", _hoisted_8, "expand_more")) : createCommentVNode("", true)], 2)]), createVNode("div", _hoisted_9, [createVNode("div", _hoisted_10, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.config.orders, (order, index) => {
    return openBlock(), createBlock("div", {
      class: "dropdown-item columns",
      key: index
    }, [createVNode("div", _hoisted_11, [createVNode("h6", _hoisted_12, toDisplayString(order.title), 1)]), createVNode("div", _hoisted_13, [createVNode("button", {
      class: ["button is-inverted", {
        'is-primary': _ctx.orderBy.name === order.name && _ctx.orderBy.value,
        'is-grey': !_ctx.orderBy.value
      }],
      onClick: $event => _ctx.setOrderBy(order.name)
    }, [_ctx.orderBy.name !== order.name || !_ctx.orderBy.value ? (openBlock(), createBlock("span", _hoisted_14, "unfold_more")) : createCommentVNode("", true), _ctx.orderBy.name === order.name && _ctx.orderBy.value === 'ASC' ? (openBlock(), createBlock("span", _hoisted_15, "expand_less")) : createCommentVNode("", true), _ctx.orderBy.name === order.name && _ctx.orderBy.value === 'DESC' ? (openBlock(), createBlock("span", _hoisted_16, "expand_more")) : createCommentVNode("", true)], 10, ["onClick"])])]);
  }), 128))])])], 2), createVNode("div", {
    class: ["dropdown is-right", {
      'is-active': _ctx.showFilters
    }],
    onClick: _cache[4] || (_cache[4] = withModifiers(() => {}, ["stop"]))
  }, [createVNode("div", _hoisted_17, [createVNode("button", {
    class: ["button is-light ml-2", {
      'is-primary': _ctx.isFiltered(),
      'is-grey': false
    }],
    onClick: _cache[3] || (_cache[3] = $event => {
      _ctx.showOrders = false;
      _ctx.showFilters = !_ctx.showFilters;
    })
  }, [_hoisted_18], 2)]), createVNode("div", _hoisted_19, [createVNode("div", _hoisted_20, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.config.conditions, (condition, index) => {
    return openBlock(), createBlock("div", {
      class: "dropdown-item columns",
      key: index
    }, [createVNode("div", _hoisted_21, [createVNode("h6", _hoisted_22, toDisplayString(condition.title), 1)]), createVNode("div", _hoisted_23, [withDirectives(createVNode("select", {
      name: `operator_${condition.name}`,
      class: "input",
      "onUpdate:modelValue": $event => _ctx.conditions[condition.name].operator = $event
    }, [_hoisted_24, _hoisted_25, _hoisted_26], 8, ["name", "onUpdate:modelValue"]), [[vModelSelect, _ctx.conditions[condition.name].operator]])]), createVNode("div", _hoisted_27, [createVNode("input", {
      name: `filter_${condition.name}`,
      class: "input",
      type: "search",
      onInput: $event => _ctx.debounce(() => {
        _ctx.conditions[condition.name].value = $event.target.value;
      })
    }, null, 40, ["name", "onInput"])])]);
  }), 128))])])], 2)]), renderSlot(_ctx.$slots, "default", {
    items: _ctx.result.data
  }), _ctx.result.error ? (openBlock(), createBlock("div", _hoisted_28, toDisplayString(_ctx.result.error), 1)) : createCommentVNode("", true), createVNode(_component_TPPagination, {
    pages: _ctx.result.pages,
    page: _ctx.page,
    "onUpdate:page": _cache[5] || (_cache[5] = $event => _ctx.page = $event)
  }, null, 8, ["pages", "page"])]);
});

script$2.render = render$2;
script$2.__scopeId = "data-v-904eb2c6";

var script$1 = defineComponent({
  name: 'TPDataListApi',
  components: {
    TPDataListCore: script$2
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ['fetch'],

  setup(props, {
    emit
  }) {
    const result = ref({
      data: []
    });

    async function fetch(params) {
      const conditions = {};
      let page = 1;

      if (params) {
        for (const condition of params.conditions) {
          const conditionObj = {};
          Reflect.set(conditionObj, condition.operator, condition.value);
          Reflect.set(conditions, condition.name, conditionObj);
        }

        if (params.orderBy) {
          Reflect.set(conditions, 'sort_by', params.orderBy.name);
          Reflect.set(conditions, 'order', params.orderBy.value);
        }

        if (params.page) page = params.page;
      }

      if (props.config.pageSize) {
        Reflect.set(conditions, 'limit', props.config.pageSize);
        Reflect.set(conditions, 'offset', props.config.pageSize * (page - 1));
      }

      result.value.loading = true;
      result.value.error = undefined;

      try {
        const response = await props.config.api.get('?' + lib.stringify(conditions));
        result.value.data = response.data;

        if (props.config.pageSize) {
          result.value.pages = Math.ceil(parseInt(response.headers['x-total-count']) / props.config.pageSize);
        }

        emit('fetch', result.value.data);
        result.value.loading = false;
      } catch (e) {
        result.value.data = [];
        result.value.pages = undefined;
        result.value.error = e.response.data.message;
        result.value.loading = false;
      }
    }

    onMounted(() => {
      fetch();
    });
    return {
      result,
      fetch
    };
  }

});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TPDataListCore = resolveComponent("TPDataListCore");

  return openBlock(), createBlock(_component_TPDataListCore, {
    config: _ctx.config,
    result: _ctx.result,
    onFetch: _ctx.fetch
  }, {
    default: withCtx(slotProps => [renderSlot(_ctx.$slots, "default", {
      items: slotProps.items
    })]),
    _: 3
  }, 8, ["config", "result", "onFetch"]);
}

script$1.render = render$1;

var script = defineComponent({
  name: 'TPDataListJson',
  components: {
    TPDataListCore: script$2
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    json: {
      type: Array,
      required: true
    }
  },
  emits: ['fetch'],

  setup(props, {
    emit
  }) {
    const result = ref({
      data: []
    });

    async function fetch(params) {
      let page = 1;
      result.value.data = props.json;

      if (params) {
        if (params.conditions.length) {
          result.value.data = params.conditions.reduce((acc, condition) => {
            return acc.filter(el => {
              const original = Reflect.get(el, condition.name).toLowerCase();
              let filter = condition.value.toLowerCase();
              if (typeof original === 'number') filter = parseFloat(filter);
              if (typeof original === 'boolean') filter = !!filter;

              if (condition.operator === 'eq') {
                return original === filter;
              } else if (condition.operator === 'like') {
                return original.includes(filter);
              } else if (condition.operator === 'gt') {
                return original > filter;
              } else if (condition.operator === 'gte') {
                return original >= filter;
              } else if (condition.operator === 'lt') {
                return original < filter;
              } else if (condition.operator === 'lte') {
                return original <= filter;
              } else if (condition.operator === 'not') {
                return original !== filter;
              } else {
                return true;
              }
            });
          }, result.value.data);
        }

        if (params.orderBy) {
          result.value.data = result.value.data.sort((a, b) => {
            let order = Reflect.get(a, params.orderBy.name) > Reflect.get(b, params.orderBy.name) ? 1 : -1;
            if (params.orderBy.value === 'DESC') order = order * -1;
            return order;
          });
        }

        if (params.page) page = params.page;
      }

      if (props.config.pageSize) {
        const position = (page - 1) * props.config.pageSize;
        result.value.pages = Math.ceil(result.value.data.length / props.config.pageSize);
        result.value.data = result.value.data.slice(position, position + props.config.pageSize);
      }

      emit('fetch', result.value.data);
    }

    onMounted(() => {
      fetch();
    });
    return {
      result,
      fetch
    };
  }

});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TPDataListCore = resolveComponent("TPDataListCore");

  return openBlock(), createBlock(_component_TPDataListCore, {
    config: _ctx.config,
    result: _ctx.result,
    onFetch: _ctx.fetch
  }, {
    default: withCtx(slotProps => [renderSlot(_ctx.$slots, "default", {
      items: slotProps.items
    })]),
    _: 3
  }, 8, ["config", "result", "onFetch"]);
}

script.render = render;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TPPagination: script$6,
  TPDataGridCore: script$5,
  TPDataGridApi: script$4,
  TPDataGridJson: script$3,
  TPDataListCore: script$2,
  TPDataListApi: script$1,
  TPDataListJson: script
});

// Import vue components

const install = function installVue3DataComponents(app) {
  Object.entries(components).forEach(([componentName, component]) => {
    app.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export default install;
export { script$4 as TPDataGridApi, script$5 as TPDataGridCore, script$3 as TPDataGridJson, script$1 as TPDataListApi, script$2 as TPDataListCore, script as TPDataListJson, script$6 as TPPagination };
